import { NUCLEUS_VAULTS } from '@/constants/nucleus-vaults';
import { QueryKey } from '@/constants/shared';
import { isTruthy } from '@/utils';
import { getVaultByKey } from '@molecularlabs/nucleus-frontend';
import { useQuery } from '@tanstack/react-query';

export const useNucleusVaults = () => {
  const {
    data: nucleusVaults = [],
    isPending: isPendingVaults,
    error,
  } = useQuery({
    queryKey: [QueryKey.NucleusVaults],
    queryFn: async () => {
      const vaults = await Promise.all(
        NUCLEUS_VAULTS.map(async (vaultMetadata) => {
          try {
            const vault = await getVaultByKey(vaultMetadata.vaultKey);
            return {
              ...(vault ?? {}),
              vaultMetadata,
            };
          } catch (e) {
            console.error(e);
            return null;
          }
        }),
      );
      return vaults.filter(isTruthy);
    },
  });
  return {
    nucleusVaults,
    isPendingVaults,
    vaultsError: error,
  };
};
